import * as React from 'react';
import { CoreLinearProgressBar as CoreProgressBar } from '../internal/WixUiCoreComponents/components/CoreLinearProgressBar';
import { st, classes } from './ProgressBar.st.css';
/** ProgressBar component based on LinearProgressBar from wix-ui-core */
export class ProgressBar extends React.PureComponent {
    render() {
        const { size, className, ...rest } = this.props;
        return (React.createElement(CoreProgressBar, { className: st(classes.root, { size }, className), ...rest }));
    }
}
ProgressBar.displayName = 'ProgressBar';
ProgressBar.defaultProps = {
    value: 0,
    size: 'small',
};
//# sourceMappingURL=ProgressBar.js.map